import { render, staticRenderFns } from "./_purgeIBCMatchLog.vue?vue&type=template&id=8ee99fc8&scoped=true&lang=pug&"
import script from "./_purgeIBCMatchLog.vue?vue&type=script&lang=js&"
export * from "./_purgeIBCMatchLog.vue?vue&type=script&lang=js&"
import style0 from "./_purgeIBCMatchLog.vue?vue&type=style&index=0&id=8ee99fc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ee99fc8",
  null
  
)

export default component.exports